<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">Gestion des réferentiels</h1>
        </div>

        <div class="col-lg-12">

            <div class="row">

                <div class="col-lg-4 pl-0">
                    <select @change="displayTab()" v-model="repo" class="form-control col-sm-12 col-md-6" id="selectTab">
                        <option v-for="repo in arrayRepository" :value="repo.model">{{repo.label}}</option>
                    </select>
                </div>

                <div class="col-lg-8 pr-0">
                    <div class="d-flex align-items-center justify-content-end">
                        <a :href="downloadModelImport" class="mr-4" title="Télécharger le modèle">
                            <i class="fas fa-download" title="Télécharger le modèle"></i>
                        </a>
                        <import-csv :api="apiImportFile"></import-csv>
                    </div>
                </div>

            </div>

        </div>

        <datatable
                :data="data.data"
                :fields="data.fields"
                :perPage="data.perPage"
                v-on:action="action_1($event)"
                :is-editable="isEditable"
                :repo="repo"
                class="table"
        >
        </datatable>

        <modal :showModal="showModal" :hideModal="hideModal">
            <h5 slot="header">
                Édition d'un champ
            </h5>

            <span slot="body" class="w-100">
                <div class="row mt-2 mb-2 parent" v-for="(value, key) in modalData"
                     v-show="key !== 'created_at' && key !== 'updated_at'">
                    <div class="col-lg-4">
                        <span>{{ translatedFields[key] ? removeBr(translatedFields[key]) : key }}</span>
                    </div>
                    <div class="col-lg-8" v-if="ajout === true">
                        <input type="text" class="form-control" v-model="modalAddData[key]" :disabled="key === 'id'"
                               v-if="modalTypeData[key] === 'string'"/>
                        <input type="number" class="form-control" v-model="modalAddData[key]" :disabled="key === 'id'"
                               v-if="modalTypeData[key] === 'integer'"/>

                        <select v-model="modalAddData[key]" class="form-control"
                                v-if="modalTypeData[key] === 'boolean'">
                            <option :value="1">True</option>
                            <option :value="0">False</option>
                        </select>
                    </div>
                    <div class="col-lg-8" v-if="ajout === false">
                        <input type="text" class="form-control" v-model="modalData[key]" :disabled="key === 'id'"
                               v-if="modalTypeData[key] === 'string'"/>
                        <input type="number" class="form-control" v-model="modalData[key]" :disabled="key === 'id'"
                               v-if="modalTypeData[key] === 'integer'"/>

                        <select v-model="modalData[key]" class="form-control" v-if="modalTypeData[key] === 'boolean'">
                            <option :value="1">True</option>
                            <option :value="0">False</option>
                        </select>
                    </div>
                </div>
            </span>

            <span slot="footer">
                <button class="btn btn-success" @click="editData">Valider</button>
                <button class="btn btn-danger" @click="hideModal">Fermer </button>
            </span>
        </modal>

        <infringement-search-result-modal></infringement-search-result-modal>

    </div>
</template>

<script>

    import Datatable from './layout/Datatable';
    import Swal from 'sweetalert2';
    import Modal from './layout/Modal';
    import ImportCsv from './layout/ImportCsv';
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";

    export default {
        components: {
            Datatable,
            Modal,
            ImportCsv,
            InfringementSearchResultModal
        },
        data() {
            return {
                data: {data: [], fields: [], perPage: 10, moreParams: []},
                arrayRepository: [],
                typeColumns: [],
                repo: '',
                showModal: false,
                modalData: {},
                modalTypeData: {},
                columns: {},
                ajout: '',
                modalAddData: {},
                searchText: '',
                actualData: [],
                importInProgress: false,
                isEditable: 0,
                translatedFields: {
                    'id': 'N° unique',
                    'last_name': 'Nom',
                    'first_name': 'Prénom',
                    'registration_number': 'Immatriculation',
                    'code_verbalizing': 'Code verbalisation',
                    'active': 'Actif',
                    'checksum': 'Checksum',
                    'import_managed_at': 'Importé le',
                    'phone': 'Téléphone',
                    'role_officers_id': 'N° Rôle',
                    'network_id': 'N° Réseau',
                    'code': 'Code',
                    'label': 'Libellé',
                    'delivery_date': 'Date de<br/>livraison',
                    'delivery_authority': 'Autorité de<br/>livraison',
                    'delivery_num': 'N° de<br/>livraison',
                    'other': 'Autre',
                    'mrz_code': 'Code MRZ',
                    'code_natinf': 'Code<br/>natinf',
                    'priority': 'Priorité',
                    'infringement_class': 'Classe<br/>d\'infraction',
                    'extra_information': 'Informations<br/>complémentaires',
                    'short_label': 'Libellé court',
                    'is_eligible': 'Éligible',
                    'code_reason': 'Code raison',
                    'amount_fine_1': 'Montant<br/>amende 1',
                    'amount_fine_2': 'Montant<br/>amende 2',
                    'amount_fine_3': 'Montant<br/>amende 3',
                    'amount_if': 'Montant<br/>IF',
                    'administrative_costs_minor': 'Frais<br/>administratifs<br/>mineurs',
                    'administrative_costs_major': 'Frais<br/>administratifs<br/>majeurs',
                    'subscription': 'Abonnement',
                    'code_type_vehicle': 'Code type<br/>véhicule',
                    'is_generic': 'Générique',
                },
                invisibleFields: [
                    'checksum',
                    'import_managed_at',
                ]
            }
        },
        created() {
            axios.get('/api/repository')
                .then(result => {
                    _.forEach(result.data, value => {
                        this.arrayRepository.push(value);
                    });

                    this.repo = this.arrayRepository[0].model;
                    this.displayTab();
                });
        },
        methods: {
            removeBr(item) {
                return item.replace(/<br\s*\/?>/mg, " ");
            },
            displayTab() {
                this.modalAddData = {};

                this.arrayRepository.forEach((el, index) => {
                    if (el.model === this.repo) this.isEditable = el.is_editable;
                });

                axios.get("/api/repositories/" + this.repo).then(response => {
                    if (this.repo === "officer") {
                        this.data.data = _.orderBy(response.data.data, 'last_name', 'asc');
                    } else {
                        this.data.data = response.data.data;
                    }

                    this.typeColumns = response.data.type_columns;
                    this.data.fields = response.data.fields.map(field => {
                        if (this.invisibleFields.includes(field.name) === true) {
                            return {
                                'name': field.name,
                                'visible': false,
                            };
                        }

                        if (typeof field === 'object') {
                            return {
                                'name': field.name,
                                'title': this.translatedFields[field.name] ? this.translatedFields[field.name] : field.name
                            };
                        }
                        return field;
                    });

                    this.actualData = this.data.data;
                    if (this.isEditable === 1) this.data.fields.push('actions');

                    this.getColumn(response.data.fields);
                })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            getColumn(data) {
                this.columns = [];
                _.forEach(data, value => {
                    if (value.name !== 'id') {
                        this.columns.push(value.name);
                    }
                });
            },

            action_1(event) {
                let i = 0;

                //dans le cas d'une supression
                if (event.action === "delete-item") {
                    Swal({
                        title: 'Êtes vous sur ?',
                        text: "Vous ne pourrez pas revenir en arrière.",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Annuler',
                        confirmButtonText: 'Supprimer'
                    }).then((result) => {
                        if (result.value) {
                            axios.delete('/api/repositories/' + this.repo + '/' + event.data.id)
                                .then(result => {
                                    Swal(
                                        'Supprimée !',
                                        'Ligne supprimée.',
                                        'success'
                                    );
                                    //on récup la data a delete
                                    let test = _.find(this.data.data, {'id': event.data.id});
                                    //on supprime la data du tableau pour ensuite rafraichir
                                    this.data.data = _.remove(this.data.data, (data) => {
                                        if (this.data.data.length === 1) {
                                            this.displayTab();
                                        } else {
                                            return data.id !== test.id;
                                        }
                                    });

                                    this.actualData = _.remove(this.actualData, (data) => {
                                        if (this.actualData.length === 1) {
                                            this.displayTab();
                                        } else {
                                            return data.id !== test.id;
                                        }
                                    });
                                });
                        }
                    });
                }
                //dans le cas d'une édition
                else if (event.action === "edit-item") {
                    _.each(this.data.fields, (field) => {
                        if (field !== "actions") {
                            this.modalTypeData[field.name] = this.typeColumns[i];
                            i++;
                        }
                    });

                    this.ajout = false;
                    this.showModal = true;
                    this.modalData = event.data;
                }
                //dans le cas d'un ajout
                else if (event.action === "reset-password") {
                    this.confirmResetPassword(event.data.id);
                } else {
                    this.modalData = {};
                    this.modalTypeData = {};

                    _.each(this.data.fields, (field) => {
                        if (field !== "actions") {
                            this.modalData[field.name] = "";
                            this.modalTypeData[field.name] = this.typeColumns[i];
                            i++;
                        }
                    });

                    this.ajout = true;
                    this.showModal = true;
                }
            },

            hideModal() {
                this.showModal = false;
            },

            confirmResetPassword(id) {
                Swal({
                    title: 'Modifier le mot de passe de l\'agent ?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Annuler',
                    confirmButtonText: 'Modifier'
                }).then((result) => {
                    if (result.value) {
                        this.resetPassword(id);
                    }
                });
            },

            resetPassword(id) {
                axios.get('/api/users/reset_password', {
                    params: {
                        id: id
                    }
                })
                    .then(result => {
                        Swal(
                            'Mot de passe :',
                            result.data,
                            'info'
                        );
                        this.showModal = false;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            editData() {
                //dans le cas d'une édition
                if (this.ajout === false) {
                    axios.put('/api/repositories/' + this.repo + '/' + this.modalData.id, {
                        data: this.modalData,
                        columns: this.columns
                    })
                        .then(result => {
                            Swal(
                                'Modifié !',
                                'Element modifié.',
                                'success'
                            );
                            this.showModal = false;
                        })
                        .catch(error => {
                            console.log(error.message)
                        });
                }
                //dans le cas d'un ajout
                else {
                    let code = this.modalAddData.code;
                    let codeOk = true;

                    if (code) {
                        let exist = this.data.data.filter(function (data) {
                            if (data.code == code) return true;
                        });

                        if (exist.length > 0) {
                            Swal(
                                'Erreur',
                                'Le code indiqué est déjà utilisé, veuillez en choisir un autre !',
                                'error'
                            );

                            codeOk = false;
                        }
                    }


                    if (codeOk) {
                        axios.post('/api/repositories/' + this.repo, {
                            data: this.modalAddData,
                            columns: this.columns
                        })
                            .then(result => {
                                Swal(
                                    'Ajouté !',
                                    'Element ajouté.',
                                    'success'
                                );

                                delete result.data.created_at;
                                delete result.data.updated_at;

                                this.data.data.push(result.data);
                                this.showModal = false;
                                this.modalAddData = {};

                                if (this.repo === 'officer') {
                                    this.resetPassword(result.data.id);
                                }
                            })
                            .catch(error => {
                                console.log(error.message)
                            });
                    }
                }
            },

            research(text) {
                let filteredData = [];
                if (text === "") {
                    this.displayTab();
                }

                this.actualData.filter((data) => {
                    let trouve = false;

                    _.forEach(data, function (value, key) {
                        if (value !== null && key !== 'id') {
                            let d = value.toString();
                            let k = d.toLowerCase();
                            let t = text.toLowerCase();

                            if (k.match(t) && trouve === false) {
                                filteredData.push(data);
                                trouve = true;
                            }
                        }
                    })
                });
                this.data.data = filteredData;
                if (filteredData.length === 0) {
                    Swal(
                        'Aucun résultat !',
                    );
                }
            }
        },
        computed: {
            apiImportFile() {
                return `/api/repositories/${this.repo}/import`;
            },
            downloadModelImport() {
                return `/download/csv/models/${this.repo}`;
            }
        }
    }
</script>

<style scoped>
    #selectTab {
        margin-bottom: 19px;
        max-width: 500px;
    }

    #vueTableRef {
        background-color: white;
        padding: 25px;
    }

    .header-table {
        display: flex;

        align-items: center;
    }

    .flex-align-right {
        margin-left: auto;
    }

    .import-container {
        display: flex;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/Repository.vue